import "./AssetReportCss.css";
import { useState, useEffect } from "react";
import SessionBar from '../Components/SessionBar/SessionBar';
import api from "../services/api";

const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export default function AssetVerificationReport() {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [division, setDivision] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchDivisions = async () => {
            try {
                const { data } = await api.get('/config/divisions');
                setDivisions(data);
                // if (data.length > 0) setDivision(data[0].division);
            } catch (err) {
                if (err.message === 'Session expired') {
                    return;
                }
                console.error('Error fetching divisions:', err);
            }
        };
        fetchDivisions();
    }, []);

    const handleDownload = async () => {
        if (!fromDate || !toDate) {
            alert('Please select both dates');
            return;
        }
        if (!division) {
            alert('Please select a division');
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post('/reports/assets/verification', {
                from_date: fromDate,
                to_date: toDate,
                divisions: division
            });

            const csv = [
                ['Division', 'User', 'Asset No', 'Verified On'],
                ...data.map(row => [
                    row.division,
                    row.verified_by,
                    row.asset_no,
                    formatDate(row.verified_on)
                ])
            ].map(row => row.map(cell => {
                const val = cell == null ? '' : String(cell);
                const escaped = val.replace(/"/g, '""');
                return /[,"\n\r]/.test(escaped) || /^[=+\-@]/.test(escaped)
                    ? `"'${escaped}"`
                    : escaped;
            }).join(',')).join('\n');

            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `verification_report_${division}_${fromDate}_${toDate}.csv`;
            a.click();
        } catch (err) {
            if (err.message === 'Session expired') {
                return;
            } else {
                console.error(err);
                alert('Failed to download report');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="verification-container">
            <SessionBar name='Asset Verification Report' />
            <br />
            <br />
            <br />
            <br />
            <table className="styled-table">
                <tbody>
                    <tr>
                        <td id="MainRow">From Date</td>
                        <td id="Value">
                            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                        </td>
                    </tr>
                    <tr>
                        <td id="MainRow">To Date</td>
                        <td id="Value">
                            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        </td>
                    </tr>
                    <tr className="LastRow">
                        <td id="MainRow1">Division</td>
                        <td id="Value1">
                            <div className="scroll-list-container">
                                <div className="scroll-list">
                                    {divisions.map(div => (
                                        <div
                                            key={div.division}
                                            className={`scroll-item ${division.includes(div.division) ? 'selected' : ''}`}
                                            onClick={(e) => {
                                                if (e.ctrlKey || e.metaKey) {
                                                    // Toggle in multi-select mode
                                                    setDivision(prev =>
                                                        prev.includes(div.division)
                                                            ? prev.filter(d => d !== div.division)
                                                            : [...prev, div.division]
                                                    );
                                                } else {
                                                    // Single click replaces selection
                                                    setDivision([div.division]);
                                                }
                                            }}
                                        >
                                            {div.division}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div className="button-container">
                <button className="download-btn" onClick={handleDownload} disabled={loading}>
                    {loading ? 'Downloading...' : 'Download'}
                </button>
            </div>
        </div>
    )
}